<template>
  <div class="login">
    <select class="sel_opt" v-model="selectValue" @change="langChange" placeholder="切换语言">
      <option
        v-for="item in options"
        :key="item.label"
        :label="item.label"
        :value="item.value"
      ></option>
    </select>
    <van-nav-bar :title="$t('message.login.lo_reg')" fixed placeholder />
    <!-- <div class="login_title">{{ $t('message.login.lo_reg') }}</div> -->
    <div class="login_title"></div>
    <div class="login_choice">{{ $t('message.login.select_log_reg') }}</div>
    <div class="login_phone_btn" @click="phoneClick">
      <i class="iconfont icon-jr-icon-phone"></i>
      <span>{{ $t('message.login.log_num') }}</span>
    </div>
    <div class="login_wechat_btn" @click="wechatClick" v-if="weixin">
      <i class="iconfont icon-jr-icon-chat"></i>
      <span>{{ $t('message.login.log_wet') }}</span>
    </div>
    <div class="bottom">
      <van-checkbox icon-size="16px" v-model="checked">
        {{ $t('message.login.agree_read') }}
      </van-checkbox>
      <div class="div" @click="privacy">{{ $t('message.login.privacy') }}</div>
    </div>
    <van-popup v-model="showTxt" class="text_pop">
      <user-text-pop />
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant'
import UserTextPop from './components/UserTextPop.vue'
export default {
  components: { UserTextPop },
  name: 'Login',
  data() {
    return {
      checked: true,
      showTxt: false,
      weixin: false,
      selectValue: '',
      options: [
        {
          value: 'zhcn',
          label: '中文'
        },
        {
          value: 'en',
          label: 'English'
        }
      ]
    }
  },

  created() {
    let that = this
    that.selectValue = sessionStorage.lang == undefined ? 'zhcn' : sessionStorage.lang
    this.is_weixin()
    console.log(sessionStorage.lang || 'zhcn')
    //console.log(sessionStorage.lang);
  },
  methods: {
    // 判断是否是微信浏览器
    is_weixin() {
      var useragent = navigator.userAgent
      if (useragent.match(/MicroMessenger/i) != 'MicroMessenger') {
        this.weixin = false
      } else {
        this.weixin = true
      }
    },
    langChange() {
      sessionStorage.setItem('lang', this.selectValue)
      this.$i18n.locale = this.selectValue
      // console.log(this.selectValue);
      //console.log(this.$i18n.locale);
      this.$router.go(0)
    },
    privacy() {
      this.showTxt = true
    },
    phoneClick() {
      if (!this.checked) {
        Toast.fail(this.$t('message.login.check_agree'))
      } else {
        this.$router.push({
          name: 'LoginInfo'
        })
      }
    },
    wechatClick() {
      if (!this.checked) {
        Toast.fail(this.$t('message.login.check_agree'))
      } else {
        //本地  'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf746a75916d3a730&redirect_uri=http://192.168.0.19:8081/login/open&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
        //测试库 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf746a75916d3a730&redirect_uri=https://h5dev.cnsmeta.cn/login/open&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
        //线上  'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf15830647c136b0b&redirect_uri=https://h5.cnsmeta.cn/login/open&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
        // window.open(
        //   'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf15830647c136b0b&redirect_uri=https://h5.cnsmeta.cn/login/open&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
        // )
        const url =
          window.location.protocol +
          '//' +
          window.location.host +
          '/middlePage?url=' +
          window.location.protocol +
          '//' +
          window.location.host
        window.open(url, '_self')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  width: 100%;
  height: 100vh;
  background-color: #fff;
  box-sizing: border-box;
  padding: 0 16px;

  /deep/ .van-popup__close-icon {
    position: fixed !important;
  }

  .text_pop {
    width: 90%;
    height: 80%;
    border-radius: 12px;
  }

  .bottom {
    width: 100%;
    overflow: hidden;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    bottom: 60px;
    left: 0;
    text-align: center;

    /deep/ .van-checkbox__label {
      color: #999999;
      font-size: 10px;
      font-weight: 400;
    }

    .div {
      color: #3562ff;
      font-size: 10px;
      font-weight: 400;
      line-height: 12px;
      margin-left: 2px;
    }
  }

  /deep/ .van-hairline--bottom::after {
    border: none !important;
  }

  .login_title {
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 15px 0;
    color: #151515;
    font-weight: 500;
    font-size: 20px;
    margin: 15px 0;
    border-bottom: 1px solid #efefef;
  }

  .login_choice {
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding-top: 30px;
    margin: 0 0 50px 0;
    text-align: center;
    color: #999999;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5em;
  }

  .login_phone_btn {
    width: 280px;
    height: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 400;
    border-radius: 32px;
    background-color: #3360ff;
    margin: 0 auto;
    i {
      margin-right: 4px;
    }
  }

  .login_wechat_btn {
    width: 260px;
    height: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 400;
    border-radius: 32px;
    box-sizing: border-box;
    margin: 25px auto;
    border: 1px solid #e0e0e0;

    i {
      margin-right: 4px;
    }
  }
}
.sel_opt {
  position: absolute;
  top: 15px;
  z-index: 9999;
  right: 10px;
  border: 1px solid #bebdbd;
  color: darkgray;
  outline: none;

  option {
    color: #3c3b3f;
  }
}
</style>
